import axios from 'axios';
import { collaborationApi, docCollaborationApi, convertApis, getFileBufferByUrl } from 'Api/index';
import { store } from 'Store/store.index';
import { fileController } from '@/components/viewer/Controllers/index';
// import { baseUrlApis } from '@/api/index'
import { /*URL_CWS_API, */ TASK_STATUS } from 'Api/constants';
import { compareDate } from '@/utils/date';
import { /*filterAnnotationData, getAnnotInReplyTo,*/ enableCollaborationOnlyRead, getAnnotRenderInfo, setAnnotToXFDF } from '@/utils/sdk_utils';
import { collaborationAnnotEvent } from './index';
import intl from 'react-intl-universal';
import { message } from '@/../node_modules/antd/lib/index';
import { ENTER_REVIEW_MODE_SUCCESS, ENTER_REVIEW_MODE_FAILED } from 'Components/viewer/ui/constants/user.more.constants';
import { /*getQueryVariable,*/ isPhantomOnline } from '@/utils/utils';
import { COLLABORATION_FILE_SIZE_LIMIT } from '@/limit.constant';
import { COLLABORATION_FILE_UPLOAD_FINISH, COLLABORATION_FILE_UPLOAD_START } from '@/constants/app.constant';
import * as APP_CONSTANTS from 'Constants/app.constant';

//let myAnnotLastUpdate
let othersAnnotLastUpdate;
//let getAnnotListDebounce
//let getSelfAnnotListDebounce
const blockSize = 30 * 1024 * 1024;
const maxChunks = 100000;
const tokenError = 'get user token error';
const cDocIdError = 'get cDocID error';
const currentDocError = 'get currentDoc error';
const uploadFileError = 'upload file error';
const cancelUpload = 'cancel upload';

const header = `<?xml version="1.0" encoding="UTF-8"?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><annots>`;
const tail = `</annots></xfdf>`;

export default class CollaborationService {
  constructor() {
    this.cDocID = '';
    this.docName = '';
    this.fileLink = '';
    this.reviewSessionID = '';
    this.token = null;
    this.cUserID = null;
    this.userEmail = null;
    this.isRestoreAnnotsForCache = false;
    this.isDocModifiedBeforeShare = false;
    this.isCancelCreateShareReview = false;
  }
  updateIsCancelCreateShareReview(value) {
    this.isCancelCreateShareReview = value;
  }
  resetIsCancelCreateShareReview() {
    this.isCancelCreateShareReview = false;
  }
  cancelUploadShareReview() {
    collaborationApi.cancelUploadShareReview();
  }
  dingtalkSetCollaborationData(cDocID, fileName, docUrl, reviewSessionID) {
    this.cDocID = cDocID;
    this.docName = fileName;
    this.fileLink = docUrl;
    this.reviewSessionID = reviewSessionID;
  }
  updateIsRestoreAnnotsForCache(value) {
    this.isRestoreAnnotsForCache = value;
  }
  resetIsRestoreAnnotsForCache() {
    this.isRestoreAnnotsForCache = false;
  }
  clean() {
    this.token = null;
  }
  // TODO FOXIT 发起协同获取用户信息， 云编辑改造
  async getUserToken() {
    if (this.token) {
      return;
    }
    const userTokenResult = await docCollaborationApi.getUserToken().catch((error) => {
      throw error;
    });
    let tokenRes = null;
    if (userTokenResult) {
      tokenRes = userTokenResult.ret;
    }
    if (tokenRes !== 0) {
      throw tokenError;
    }

    this.token = userTokenResult.data.token;
    this.cUserID = userTokenResult.data.cUserID;
    // this.userEmail = userTokenResult.data.userEmail
    // TODO FOXIT 获取更新token
    this.userEmail = userTokenResult.data.userEmail || userTokenResult.data.userMobile;
    collaborationApi.setToken(userTokenResult.data.token);
    store.userNewStore.updateToken(this.token);
    // store.userStore.updateToken(this.token)
    store.collaborationStore.setUserInfo({
      token: this.token,
      cUserID: this.cUserID,
      userEmail: this.userEmail,
    });
  }
  // TODO FOXIT 发起协同创建链接，云编辑重新，原方法注释保留在下方
  async createShareFileLink(option = {}, type = 'create') {
    console.log('发起协同创建链接');
    console.log(option);
    const { deadline, shareDescribe, prohibitComment, userEmail, extDocID, message } = option;
    let reviewSessionID = '';
    let fileName = '';
    let docUrl = '';
    let hasFileLink = false;
    // let hasFileLisk = false
    // TODO FOXIT 获取打开文档的大小，该方法未调用接口，调用底层pdfui.getCurrentPDFDoc,云编辑不修改
    const isOverSize = await this.fileOverSizeCheck();
    // 文件超过30M提示
    if (isOverSize) {
      return Promise.reject({
        type: 'noAlert',
        source: 'fileSizeOver',
      });
    }
    // TODO FOXIT 修改为获取用户信息，该方法不调用接口，但需要将用户信息修改为云编辑用户
    await this.getUserToken().catch((error) => {
      throw error;
    });
    // TODO FOXIT 获取 cpdf 文档信息
    // 提前生成一个DocId用于分享创建
    let cDocID = new Date().getTime().toString() + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); // 使用时间戳做标识
    const cDocResult = await docCollaborationApi.getCDocInfo(cDocID).catch((error) => {
      throw error;
    });
    console.log('cDocResult:' + cDocResult);
    console.log(cDocResult);
    let { ret: cDocRet } = cDocResult;
    if (cDocRet !== 0) {
      throw cDocIdError;
    }
    const {
      data: { docName },
    } = cDocResult;
    // let fwConvertToCPDFResult = window.sessionStorage.getItem("fwConvertToCPDFResult")
    // let Result = fwConvertToCPDFResult && JSON.parse(fwConvertToCPDFResult)
    // console.log(Result)
    // if(Result && Result.data.ret === 110005) {
    //   const shareFileDetails = this.getShareReview({ cDocID: cDocID.toUpperCase() })
    //   if(shareFileDetails.ret === 0) {
    //     // TODO FOXIT
    //     let data = shareFileDetails.data[0]
    //     this.reviewSessionID && shareFileDetails.data.length>0 && shareFileDetails.data.forEach(item => {
    //       if(this.reviewSessionID === item.reviewSessionID) {
    //         data = item
    //       }
    //     })
    //     // const data = shareFileDetails.data[0] || {}
    //     const fileData = {
    //       docId: data.cDocID,
    //       docName: data.docName || docName,
    //       fileLink:  data.fileLink,
    //       reviewSessionID: data.reviewSessionID,
    //       success:()=>{
    //         store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_SUCCESS, null, null);
    //       },
    //       error:()=>{
    //         store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_FAILED, null, null);
    //       }
    //     }
    //     docCollaborationApi.openSharedFile(fileData);
    //   }
    //   return
    // }
    // TODO FOXIT 调用注释转fdf
    if (window.platform && window.platform === 'PhantomOnline') {
      await store.collaborationStore.updateAnnotsCache().catch((error) => {
        throw error;
      });
    }
    // TODO FOXIT 共享协作的信息
    console.log('共享协作的信息');
    const shareViewSendData = {
      cDocID: cDocID,
      shareDescribe,
      groups: ['anyone'],
      docName,
      isAnonymous: 0,
      deadline,
      prohibitComment,
      extDocID,
    };
    console.log(shareViewSendData);
    // collaborationApi.uploadShareReview 提交文档 云编辑需要更换接口信息
    const shareViewResult = await collaborationApi.uploadShareReview(shareViewSendData);
    console.log('shareViewResult:');
    if (shareViewResult.ret === 0) {
      reviewSessionID = shareViewResult.data.shareReview.reviewSessionID;
      let StorageDocId = {};
      StorageDocId[reviewSessionID] = cDocID;
      window.localStorage.setItem('fwStoregeDocId', JSON.stringify(StorageDocId));
      store.collaborationStore.setReviewSessionID(reviewSessionID);
      fileName = shareViewResult.data.shareReview.docName;

      if (window.platform && window.platform === 'PhantomOnline') {
        await this.uploadInitialAnnots().catch((error) => {
          throw error;
        });
        store.collaborationStore.updateIsUploadedInitialAnnots(true);
      } else {
        const res = await docCollaborationApi.uploadInitialAnnots({ reviewSessionID }).catch((error) => {
          store.collaborationStore.handleErrorMsg(error);
          throw error;
        });
        if (res && res.ret !== 0) {
          store.collaborationStore.handleErrorMsg(error);
          throw error;
        }
      }
    } else {
      console.log(12225555111);
      // TODO FOXIT 假如文件已上传，使用docId去获取信息
      if (shareViewResult.ret === 110002) {
        const shareFileDetails = this.getShareReview({ cDocID });
        if (shareFileDetails.ret === 0) {
          // TODO FOXIT
          let data = shareFileDetails.data[0];
          this.reviewSessionID &&
            shareFileDetails.data.length > 0 &&
            shareFileDetails.data.forEach((item) => {
              if (this.reviewSessionID === item.reviewSessionID) {
                data = item;
              }
            });
          // const data = shareFileDetails.data[0] || {}
          const fileData = {
            docId: data.cDocID.toUpperCase(),
            docName: data.docName || docName,
            fileLink: data.fileLink,
            reviewSessionID: data.reviewSessionID,
            success: () => {
              store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_SUCCESS, null, null);
            },
            error: () => {
              store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_FAILED, null, null);
            },
          };
          docCollaborationApi.openSharedFile(fileData);
        }
      } else if (shareViewResult.message === 'REVIEWSESSIONID_IS_EXIST' && shareViewResult.ret === 2100023) {
        reviewSessionID = shareViewResult.data.reviewSessionID;
        store.collaborationStore.setReviewSessionID(reviewSessionID);

        const getShareReviewResult = await this.getShareReview({ cDocID, reviewSessionID }).catch((error) => {
          throw error;
        });

        if (getShareReviewResult.ret === 0) {
          const fileData = getShareReviewResult.data[0] || {};
          fileName = fileData.docName;
          if (fileData.fileLink) {
            hasFileLink = true;
            docUrl = fileData.fileLink;
          }
        }
      } else {
        return Promise.reject(shareViewResult);
      }
    }
    console.log(12221114444);
    this.reviewSessionID = reviewSessionID;

    if (!hasFileLink) {
      // 获取CurrentDoc的文档信息
      const currentDocResult = await this.getCurrentDoc().catch((error) => {
        throw error;
      });
      let { ret: currentDocRet } = currentDocResult;

      if (currentDocRet !== 0) {
        throw currentDocError;
      }

      const { data: files } = currentDocResult;

      // 上传CurrentDoc
      if (!files) {
        throw currentDocError;
      }

      store.appStore.sendPerformanceInfo({ event: COLLABORATION_FILE_UPLOAD_START, isEmit: false, lastEvent: true });
      docUrl = await this.doUploadFile({ file: files, blockSize, onFinishCallback: () => {} }).catch((error) => {
        throw error;
      });
      store.appStore.sendPerformanceInfo({ event: COLLABORATION_FILE_UPLOAD_FINISH, isEmit: true, lastEvent: true });

      if (!docUrl) {
        store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: intl.get('collaboration.sharedList.uploadFailed') });
      }
    }

    this.cDocID = cDocID;
    this.docName = fileName;
    this.fileLink = docUrl;

    console.log(12221115555);

    // 创建协作链接
    if (type === 'create') {
      console.log(122211155556666);
      const sharedUrl = `${location.origin}/?docUrl=${encodeURIComponent(docUrl)}&fileName=${encodeURIComponent(fileName)}&reviewSessionID=${reviewSessionID}`;
      const inviteSendData = { cDocID, reviewSessionID, fileLink: docUrl };
      await this.inviteJoin(inviteSendData).catch((error) => {
        throw error;
      });
      return sharedUrl;
      // 创建协作并通过邮箱邀请协作
    } else if (type === 'inviteJoin') {
      console.log(12221115557777);
      const inviteSendData = {
        cDocID,
        reviewSessionID,
        userEmail,
        fileLink: docUrl,
        message,
      };
      const inviteResult = await this.inviteJoin(inviteSendData).catch((error) => {
        throw error;
      });

      return inviteResult;
    }
  }
  // async createShareFileLink(option={}, type='create') {
  //   const {deadline,shareDescribe,prohibitComment,userEmail, extDocID} = option
  //   let reviewSessionID = ''
  //   let fileName = ''
  //   let docUrl = ''
  //   let hasFileLisk = false
  //   // TODO FOXIT 获取打开文档的大小
  //   const isOverSize = await this.fileOverSizeCheck()

  //   if (isOverSize) {
  //     return Promise.reject({
  //       type:'noAlert',
  //       source: 'fileSizeOver'
  //     })
  //   }
  //   // TODO FOXIT 修改为获取云编辑用户token
  //   await this.getUserToken().catch((error) => {
  //     throw error
  //   })
  //   // 获取 cpdf 文档信息
  //   const cDocResult = await docCollaborationApi.getCDocInfo().catch((error) => {
  //     throw error
  //   });
  //   let { ret: cDocRet } = cDocResult;

  //   if (cDocRet !== 0) {
  //     throw cDocIdError
  //   }

  //   // TODO FOXIT 调用注释转fdf
  //   if (window.platform && window.platform === 'PhantomOnline') {
  //     await store.collaborationStore.updateAnnotsCache().catch((error) => {
  //       throw error
  //     })
  //   }

  //   const { data: { cDocID, docName }, } = cDocResult;
  //   // TODO FOXIT 共享协作的信息
  //   const shareViewSendData = {
  //     cDocID,
  //     shareDescribe,
  //     groups: ['anyone'],
  //     docName,
  //     isAnonymous: 0,
  //     deadline,
  //     prohibitComment,
  //     extDocID
  //   }
  //   // collaborationApi.uploadShareReview 提交文档 云编辑需要更换接口信息
  //   const shareViewResult = await collaborationApi.uploadShareReview(shareViewSendData).catch((error) => {
  //     store.collaborationStore.handleErrorMsg(error)
  //     throw error
  //   });

  //   // TODO FOXIT 发起共享协作的接口返回ID
  //   if(shareViewResult.ret === 0) {
  //     reviewSessionID = shareViewResult.data.shareReview.reviewSessionID
  //     store.collaborationStore.setReviewSessionID(reviewSessionID)
  //     fileName = shareViewResult.data.shareReview.docName

  //     if (window.platform && window.platform === 'PhantomOnline' && prohibitComment !== 1) {
  //       await this.uploadInitialAnnots().catch((error) => {
  //         throw error
  //       })
  //       store.collaborationStore.updateIsUploadedInitialAnnots(true)
  //     } else {
  //       const res = await docCollaborationApi.uploadInitialAnnots({reviewSessionID}).catch((error) => {
  //         store.collaborationStore.handleErrorMsg(error)
  //         throw error
  //       })

  //       if (res && res.ret !== 0) {
  //         store.collaborationStore.handleErrorMsg(error)
  //         throw error
  //       }
  //     }
  //   } else {
  //     if(shareViewResult.message==='REVIEWSESSIONID_IS_EXIST'&& shareViewResult.ret === 2100023) {
  //       reviewSessionID = shareViewResult.data.reviewSessionID
  //       store.collaborationStore.setReviewSessionID(reviewSessionID)

  //       const getShareReviewResult = await this.getShareReview({ cDocID, reviewSessionID }).catch((error) => {
  //         throw error
  //       })

  //       if(getShareReviewResult.ret === 0) {
  //         const fileData = getShareReviewResult.data[0] || {}
  //         fileName = fileData.docName
  //         if(fileData.fileLink) {
  //           hasFileLisk = true
  //           docUrl = fileData.fileLink
  //         }
  //       }
  //     } else {
  //       return Promise.reject(shareViewResult)
  //     }
  //   }

  //   this.reviewSessionID = reviewSessionID

  //   if(!hasFileLisk) {
  //     // 获取CurrentDoc的文档信息
  //     const currentDocResult =  await this.getCurrentDoc().catch((error) => {
  //       throw error
  //     })
  //     let { ret: currentDocRet } = currentDocResult;

  //     if (currentDocRet !== 0) {
  //       throw currentDocError
  //     }

  //     const { data: files, } = currentDocResult;

  //     // 上传CurrentDoc
  //     if(!files) {
  //       throw currentDocError
  //     }

  //     docUrl = await this.doUploadFile({ file: files, blockSize, onFinishCallback: () => {} }).catch((error) => {
  //       throw error
  //     })

  //     if(!docUrl){
  //       store.collaborationStore.postErrorMsg({type:'error',errorInfo:intl.get('collaboration.sharedList.uploadFailed')})
  //     }
  //   }

  //   this.cDocID = cDocID
  //   this.docName = fileName
  //   this.fileLink = docUrl

  //   if(type === 'create') {
  //     const sharedUrl = `${location.origin}/?docUrl=${encodeURIComponent(docUrl)}&fileName=${encodeURIComponent(fileName)}&reviewSessionID=${reviewSessionID}`
  //     const inviteSendData = { cDocID, reviewSessionID, fileLink:docUrl }

  //     await this.inviteJoin(inviteSendData).catch((error) => {
  //       throw error
  //     })

  //     return sharedUrl
  //   } else if(type === 'inviteJoin') {
  //     const inviteSendData = {
  //       cDocID,
  //       reviewSessionID,
  //       userEmail,
  //       fileLink:docUrl
  //     }
  //     const inviteResult = await this.inviteJoin(inviteSendData).catch((error) => {
  //       throw error
  //     })

  //     return inviteResult
  //   }
  // }
  async createShareFileLinkForTeamsApp(option = {}, type = 'create') {
    const { deadline, shareDescribe, prohibitComment, userEmail, extDocID, extDocHash, message } = option;
    // 获取CDoc文档的信息
    let reviewSessionID = '';
    let fileName = '';
    // let fileSize = ''
    let docUrl = '';
    let hasFileLink = false;

    const isOverSize = await this.fileOverSizeCheck();

    if (isOverSize) {
      return new Promise((resolve, reject) => {
        // const SingleFileSizeOver = intl.get('collaboration.Dlg.FileOverSizeCommon', { fileSize: 30 });
        // message.error(SingleFileSizeOver)
        // store.collaborationStore.postErrorMsg({
        //   type: 'error', errorInfo: SingleFileSizeOver
        // })
        return reject({
          type: 'noAlert',
          source: 'fileSizeOver',
        });
      });
    }

    await this.getUserToken();
    const cDocResult = await docCollaborationApi.getCDocInfo().catch((error) => {
      console.error(error);
    });
    let { ret: cDocRet } = cDocResult;

    if (cDocRet !== 0) {
      console.error('get cDocID error');
      return;
    }

    if (window.platform && window.platform === 'PhantomOnline') {
      await store.collaborationStore.updateAnnotsCache();
    }

    const {
      data: { cDocID, docName },
    } = cDocResult;
    const shareViewSendData = {
      cDocID,
      shareDescribe,
      groups: ['anyone'],
      docName,
      isAnonymous: 0,
      deadline,
      prohibitComment,
      extDocID,
      extDocHash,
    };
    const shareViewResult = await collaborationApi.uploadShareReview(shareViewSendData).catch((error) => {
      store.collaborationStore.handleErrorMsg(error);
    });
    if (shareViewResult.ret === 0) {
      store.collaborationStore.setShareReviewData(shareViewResult.data.shareReview);
      reviewSessionID = shareViewResult.data.shareReview.reviewSessionID;
      store.collaborationStore.setReviewSessionID(reviewSessionID);
      fileName = shareViewResult.data.shareReview.docName;

      if (window.platform && window.platform === 'PhantomOnline' && prohibitComment !== 1) {
        await this.uploadInitialAnnots().catch((error) => {
          throw error;
        });

        store.collaborationStore.updateIsUploadedInitialAnnots(true);
      } else {
        const res = await docCollaborationApi.uploadInitialAnnots({ reviewSessionID }).catch((error) => {
          store.collaborationStore.handleErrorMsg(error);
          throw error;
        });

        if (res && res.ret !== 0) {
          store.collaborationStore.handleErrorMsg(error);
          throw error;
        }
      }
    } else {
      if (shareViewResult.message === 'REVIEWSESSIONID_IS_EXIST' && shareViewResult.ret === 2100023) {
        return new Promise((resolve, reject) => {
          return reject(shareViewResult);
        });
      } else {
        return new Promise((resolve, reject) => {
          return reject(shareViewResult);
        });
      }
    }

    this.reviewSessionID = reviewSessionID;
    if (!hasFileLink) {
      // 获取CurrentDoc的文档信息
      const currentDocResult = await this.getCurrentDoc();
      let { ret: currentDocRet } = currentDocResult;
      if (currentDocRet !== 0) {
        console.log('getCurrentDoc error');
        return;
      }
      const { data: files } = currentDocResult;
      // 上传CurrentDoc
      if (!files) {
        throw 'get current file info failed';
      }
      docUrl = await this.doUploadFile({ file: files, blockSize, onFinishCallback: () => {} });
      if (!docUrl) {
        store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: intl.get('collaboration.sharedList.uploadFailed') });
      }
    }
    this.cDocID = cDocID;
    this.docName = fileName;
    this.fileLink = docUrl;
    if (type === 'create') {
      const sharedUrl = `${location.origin}/?docUrl=${encodeURIComponent(docUrl)}&fileName=${encodeURIComponent(fileName)}&reviewSessionID=${reviewSessionID}`;
      const inviteSendData = { cDocID, reviewSessionID, fileLink: docUrl };

      await this.inviteJoin(inviteSendData);

      return sharedUrl;
    } else if (type === 'inviteJoin') {
      const inviteSendData = {
        cDocID,
        reviewSessionID,
        userEmail,
        fileLink: docUrl,
        message,
      };
      const inviteResult = await this.inviteJoin(inviteSendData);

      return inviteResult;
    }
  }
  async uploadInitialAnnots() {
    if (this.isCancelCreateShareReview) {
      return;
    }

    const doc = await pdfui.getCurrentPDFDoc().catch((error) => {
      throw error;
    });
    const annotsWrapperArr = await doc.getAnnots().catch((error) => {
      throw error;
    });
    for (let i = 0; i < annotsWrapperArr.length; i++) {
      if (this.isCancelCreateShareReview) {
        break;
      }

      const annots = annotsWrapperArr[i];

      if (!annots.length) {
        continue;
      }
      const resArr = await collaborationAnnotEvent.addInitialAnnotations(annots).catch((error) => {
        throw error;
      });

      if (!resArr || !resArr.length) {
        continue;
      }

      for (let ii = 0; ii < resArr.length; ii++) {
        if (this.isCancelCreateShareReview) {
          break;
        }

        const res = resArr[ii];

        if (res && res.ret === 0) {
          const annot = collaborationAnnotEvent.getHeaderAndOriginAnnot(annots);

          for (let iii = 0; iii < annot.length; iii++) {
            if (this.isCancelCreateShareReview) {
              break;
            }

            let annotId;
            const annotData = annot[iii].headerAnnot;
            const name = annotData.getName();
            const page = annotData.page.info.index;
            const pageRender = await pdfui.pdfViewer.getPDFPageRender(page);
            const pdfPage = await pageRender.getPDFPage();

            pdfPage.annots.some((annot) => {
              const annotNameToCompare = annot.getName();

              if (annotNameToCompare === name) {
                annotId = annot.getId();

                return true;
              }
            });

            const annotRender = await pdfui.getAnnotRender(page, annotId);

            if (annotRender) {
              await annotRender.component.removeAnnot().catch((error) => {
                throw error;
              });
            }
          }
        }
      }
      // }
    }
  }
  async fileOverSizeCheck() {
    try {
      let fileSize;
      let currentDocInfoRes = await this.getCurrentDoc().catch(() => {
        throw 'get current doc info failed';
      });

      if (currentDocInfoRes.ret !== 0) {
        throw 'get current doc info ret not 0';
      }

      fileSize = currentDocInfoRes.data.size;

      if (fileSize > 1024 * 1024 * COLLABORATION_FILE_SIZE_LIMIT) {
        return true;
      }
    } catch (error) {}
  }
  async inviteJoinWithEmail(option = {}) {
    try {
      const result = await this.createShareFileLink(option, 'inviteJoin');

      return result;
    } catch (error) {
      if (store.collaborationStore.isUploadedInitialAnnots) {
        store.collaborationStore.restoreAnnotsForCache();
      }
      return Promise.reject(error);
    }
  }
  async downloadFile(options, showSpin = false) {
    let taskId = '';
    const { confText, documents, filename } = options || {};
    // const baseCWSApi = await baseUrlApis.getBaseUrlBy(URL_CWS_API)
    const baseCWSApi = 'https://share.foxitcloud.cn';
    confText.listnewUrl = `${baseCWSApi}/v1/share-review/listnew?${confText.listnewUrl}&access-token=${this.token}`;
    confText.s3Url = `${baseCWSApi}/v1/share-review/annotnew?access-token=${this.token}`;
    // confText.s3Url = `${baseCWSApi}/v1/share-review/annotnew?access-token=${this.token}`
    const docConvertResult = await convertApis.doConvert(documents, 29, { confText: JSON.stringify(confText) });
    if (docConvertResult.ret !== 0) {
      const downloadFileFailed = intl.get('collaboration.sharedList.downloadFailed');
      // store.appStore.setGlobalMessage({type: 'error', content: downloadFileFailed});
      store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: downloadFileFailed });
      return '';
    }
    taskId = docConvertResult.data.taskid;
    store.taskStore.setHasTask(true);
    store.taskStore.convertTaskId = taskId;
    return new Promise((resolve, reject) => {
      showSpin && store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.DOWNLOAD_FILE, ret: 0 });
      convertApis.doMonitorStatus(taskId, (res) => {
        showSpin && store.taskStore.onUpdateTaskMessage(res);

        if (res.ret === 0) {
          res.status = TASK_STATUS.DOWNLOAD_FILE_SUCCESS;
          showSpin && store.taskStore.onUpdateTaskMessage(res);
          const url = convertApis.doGetDownloadUrl(res.data.docid, filename);
          resolve(url);
        } else if (res.msg || res.data.errorBody) {
          reject(res);
        }

        store.taskStore.doCleanTaskFileList();
      });
    });
  }
  async confirmInvitation(options) {
    await this.getUserToken();
    // TODO FOXIT 發起協助打開文檔——获取发起的参与者
    const getParticipantResult = await collaborationApi.getShareReviewParticipant(options);
    let postReviewParticipantResult = {};

    // 未加入协作的情况下请求加入协作
    if (getParticipantResult.ret === 110004) {
      // TODO FOXIT 發起協助打開文檔——获取所有参与者
      postReviewParticipantResult = await collaborationApi.postShareReviewParticipant(options);
    }

    // 曾经加入过协作但是被移除了，请求接口重新加入协作
    if (getParticipantResult.ret === 0 && getParticipantResult.data[0].isJoin != 1) {
      postReviewParticipantResult = await collaborationApi.postShareReviewParticipant(options);
    }

    // 未加入协作重新加入后再次获取协作着的列表用于更新数据
    if (getParticipantResult.ret !== 0) {
      const reviewSessionID =
        store.collaborationStore.reviewSessionID ||
        this.reviewSessionID ||
        (store.collaborationStore.shareReviewData && store.collaborationStore.shareReviewData.reviewSessionID);
      const res = await this.getShareReviewInviteParticipant(reviewSessionID).catch(() => {
        console.error('get invite participant faild');
      });

      store.collaborationStore.updateShareReviewParticipantList(res);
    }

    return new Promise((resolve /*, reject*/) => {
      resolve(postReviewParticipantResult);
    });
  }
  async postWinSizeMsg({ name, width, height }) {
    await docCollaborationApi.postWinSizeMsg({ name, width, height });
  }
  async postDownloadFileLink({ url }) {
    await docCollaborationApi.postDownloadFileLink({ url });
  }

  async getCurrentDoc() {
    const result = await docCollaborationApi.getCurrentDoc().catch((error) => {
      throw error;
    });

    return result;
  }
  getCDocBuffer() {}
  uploadShareReview() {}
  async doUploadFile({ file, reviewSessionID }) {
    let name = file.name;
    let offset = 0;
    let chunkIndex = 0;
    let chunks = maxChunks;
    let isFinish = false;
    let fileDetail = null;
    let reTryCount = 0;
    const cleanReTry = () => {
      reTryCount = 0;
    };
    const reTry = () => {
      reTryCount++;
    };
    const isCanReTry = () => {
      return reTryCount < 3;
    };
    const isEndFn = (fileSize, dataSize, isEnd) => {
      offset += dataSize;

      if (isEnd || (!!fileSize && fileSize === offset)) {
        return true;
      }

      return false;
    };
    const isReUploadCurrentData = (result) => {
      if (axios.isCancel(result)) {
        throw cancelUpload;
      }
      if (result.ret === 0) {
        return false;
      }
      if (result.ret != 0 && result.ret !== 100006 && isCanReTry()) {
        reTry();
        return true;
      }

      throw uploadFileError;
    };

    do {
      cleanReTry();

      let bufferResult = await docCollaborationApi.getFileStream({ file, offset, blockSize }).catch((error) => {
        throw error;
      });

      if (bufferResult.ret !== 0) {
        console.error('AIService -> doUploadFile ->bufferResult error:', bufferResult);
        isFinish = true;
        break;
      }

      const { content, isEnd, dataSize, fileSize } = bufferResult.data;
      const newFileName = bufferResult.data.name;

      chunks = Math.ceil(fileSize / blockSize);
      name = newFileName ? newFileName : name;

      let data = { content, fileName: name, chunk: chunkIndex, chunks, reviewSessionID: reviewSessionID || this.reviewSessionID };
      let oResult;

      do {
        try {
          const isPhantom = !isPhantomOnline();
          oResult = await collaborationApi.uploadFileChunk(
            {
              data,
            },
            isPhantom,
          );
        } catch (error) {
          oResult = error;
        }
      } while (isReUploadCurrentData(oResult));

      if (axios.isCancel(oResult)) {
        throw uploadFileError;
      }
      if (oResult.ret === 0) {
        if (oResult.data.includes('docId=')) {
          let docId = oResult.data.split('docId=')[1].split('&')[0];
          store.shareStore.setShareDocId(docId);
        }
      } else if (oResult.ret === 100006) {
        hasThisFile = true;
        isFinish = true;
      } else if (oResult.ret != 0) {
        throw uploadFileError;
      }

      chunkIndex++;

      if (isFinish || isEndFn(fileSize, dataSize, isEnd)) {
        isFinish = true;
        fileDetail = oResult.data;
        break;
      }
    } while (true);

    // is end
    collaborationApi.releaseCurrentFileBlob();

    return new Promise((resolve) => {
      resolve(fileDetail);
    });
  }
  async getShareReview({ cDocID, reviewSessionID, getMore, extDocID }) {
    // await this.getUserToken();
    return collaborationApi.getShareReview({ cDocID, reviewSessionID, getMore, extDocID });
  }
  async putShareReview(option) {
    await this.getUserToken();
    return collaborationApi.putShareReview(option);
  }
  async putShareReviewForTeamsApp(option) {
    await this.getUserToken();
    return collaborationApi.putShareReviewForTeamsApp(option);
  }
  async putShareReviewBatch(option) {
    await this.getUserToken();
    return collaborationApi.putShareReviewBatch(option);
  }
  async getShareReviewOperandsLog({ reviewSessionID, perPage, currentPage }) {
    await this.getUserToken();
    return collaborationApi.getShareReviewOperandsLog({ reviewSessionID, perPage, currentPage });
  }
  async inviteJoin({ cDocID, reviewSessionID, userEmail, fileLink, message }) {
    const result = await collaborationApi.inviteJoin({ cDocID, reviewSessionID, userEmail, fileLink, message });

    return result;
  }
  async openSharedFile(option, bConfirmInvitation, from) {
    // 新创建的协作使用this对象数据，其他使用参数数据
    let { docId, docName, fileLink, reviewSessionID } = option || {};
    let fileLinkAddToken = '';
    let shareToken = this.token || store.userNewStore.userToken;
    if (fileLink || this.fileLink) {
      fileLinkAddToken = fileLink || this.fileLink;
      if (!fileLinkAddToken.includes('token=')) {
        fileLinkAddToken += `&token=${shareToken}`;
        this.fileLink = fileLinkAddToken;
      }
    }
    console.log('fileLinkAddToken');
    console.log(fileLinkAddToken);

    docId = docId || this.cDocID;
    docName = docName || this.docName;
    fileLink = fileLinkAddToken;
    reviewSessionID = reviewSessionID || this.reviewSessionID;

    const data = {
      docId,
      docName,
      fileLink,
      reviewSessionID,
      success: () => {
        store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_SUCCESS, null, null);
      },
      error: () => {
        store.userStore.doSendGAEventByUserEvent(ENTER_REVIEW_MODE_FAILED, null, null);
      },
    };

    store.appStore.showLoadingWithMsg({ show: true, msg: 'Loading.file' });

    if (!fileLink && !this.fileLink) {
      store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.sharedList.Error.fileLinkEmpty') });
      return Promise.reject('file link error');
    }

    await store.collaborationStore.queryShareViewData({ reviewSessionID, getMore: 1 });
    await this.onPreloadSharedFileAndAnnots({ fileLink, reviewSessionID, fileName: docName }).catch((error) => {
      console.error(error);
    });

    if (!bConfirmInvitation || !store.loginNewStore.isLogin) {
      await docCollaborationApi.openSharedFile(data).catch(() => {
        store.appStore.showLoading(false);
      });
      store.appStore.showLoading(false);

      return;
    }

    return store.collaborationStore.confirmInvitation(data.reviewSessionID).then(async (res) => {
      if (res.ret === 110015) {
        const search = window.location.search;
        if (search) {
          window.history.pushState({}, '', '/');
        }
        store.appStore.backToHomeStart();
        message.error(intl.get('collaboration.Error.limitOnJoin'));
        return Promise.reject('limit on join');
      } else {
        if (from === 'sharedList') {
          store.collaborationStore.updateIsFromSharedList(true);
        }

        await docCollaborationApi.openSharedFile(data).catch(() => {
          store.appStore.showLoading(false);
        });
        store.appStore.showLoading(false);

        return;
      }
    });
  }
  async onPreloadAnnots(reviewSessionID) {
    console.log('collaborationService.getAnnotListAll 4');
    await this.getAnnotListAll({ reviewSessionID: reviewSessionID, lastTime: '0000-00-00 00:00:00:000', pageObjNum: '-1', isInitial: true }).catch(() => {
      throw 'get annots error';
    });

    return this.getInitialAnnotsFDFArr();
  }
  async onPreloadSharedFileAndAnnots({ fileLink, reviewSessionID, fileName }) {
    // 提前加载文档和annot数据
    store.appStore.sendPerformanceInfo({ event: APP_CONSTANTS.COLLABORATION_FILE_DOWNLOAD_START, isEmit: false, lastEvent: true, fileName: true });
    const sharedDoc = await getFileBufferByUrl(fileLink).catch(() => {
      store.appStore.showLoading(false);
      throw 'get shared file error';
    });
    store.appStore.sendPerformanceInfo({ event: APP_CONSTANTS.COLLABORATION_FILE_DOWNLOAD_FINISH, isEmit: true, lastEvent: true, fileName: true });

    const annotsFDFArr = await this.onPreloadAnnots(reviewSessionID).catch((error) => {
      console.error(error);
      store.appStore.showLoading(false);
    });

    store.collaborationStore.updateSharedFileInfo({ sharedDoc, annotsFDFArr, fileName });
  }
  async openSharedFileForTeamsApp(options = {}) {
    const fileLink = options.fileLink || this.fileLink;
    const reviewSessionID = options.reviewSessionID || this.reviewSessionID;
    const docName = options.docName || this.docName;

    if (!fileLink) {
      store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.sharedList.Error.fileLinkEmpty') });
      return Promise.reject('file link error');
    }

    await this.onPreloadSharedFileAndAnnots({ fileLink, reviewSessionID, fileName: docName }).catch((error) => {
      console.error(error);
    });
    return collaborationApi.openSharedFileForTeamsApp();
  }

  async getShareRelationship() {
    await this.getUserToken();

    const result = await collaborationApi.getShareRelationship();

    return result;
  }
  async getShareReviewList({ source, sort, perPage, currentPage, docName }) {
    await this.getUserToken();

    const result = await collaborationApi.getShareReviewList({ source, sort, perPage, currentPage, docName });

    return result;
  }
  getShareReviewInviteParticipant(reviewSessionID) {
    return collaborationApi.getShareReviewInviteParticipant(reviewSessionID);
  }
  shareReviewParticipant(options) {
    return collaborationApi.shareReviewParticipant(options);
  }
  putShareReviewInviteParticipantBatch(options) {
    return collaborationApi.putShareReviewInviteParticipantBatch(options);
  }
  async getCDocId() {
    let StorageDocIdAll = JSON.parse(window.localStorage.getItem('fwStoregeDocId'));
    if (this.reviewSessionID) {
      let id = StorageDocIdAll[this.reviewSessionID];
      if (id) {
        return id;
      } else {
        if (store.collaborationStore.thisCDocId) {
          return store.collaborationStore.thisCDocId;
        } else {
          if (store.collaborationStore.reviewSessionID) {
            let infos = await this.getShareReview({ reviewSessionID: store.collaborationStore.reviewSessionID, getMore: 1 });
            return infos.data[0].cDocID;
          } else {
            if (store.shareStore.shareDocId) {
              // 当缓存中没有当前文档的cDocId，使用docId获取
              let docReviewRessionIdResulet = await collaborationApi.getDocReviewRessionId(store.shareStore.shareDocId);
              if (docReviewRessionIdResulet && docReviewRessionIdResulet.ret === 0) {
                let infos = await this.getShareReview({ reviewSessionID: docReviewRessionIdResulet.data, getMore: 1 });
                return infos.data[0].cDocID;
              }
            }
          }
        }
      }
    } else {
      if (store.collaborationStore.thisCDocId) {
        return store.collaborationStore.thisCDocId;
      } else {
        if (store.collaborationStore.reviewSessionID) {
          let infos = await this.getShareReview({ reviewSessionID: store.collaborationStore.reviewSessionID, getMore: 1 });
          return infos.data[0].cDocID;
        } else {
          if (store.shareStore.shareDocId) {
            // 当缓存中没有当前文档的cDocId，使用docId获取
            let docReviewRessionIdResulet = await collaborationApi.getDocReviewRessionId(store.shareStore.shareDocId);
            if (docReviewRessionIdResulet && docReviewRessionIdResulet.ret === 0) {
              let infos = await this.getShareReview({ reviewSessionID: docReviewRessionIdResulet.data, getMore: 1 });
              return infos.data[0].cDocID;
            }
          }
        }
      }
    }
  }
  sendCollabOp(data) {
    let reviewSessionIDForRequest = getQueryVariable('reviewSessionID') || store.collaborationStore.reviewSessionID;
    collaborationApi.sendCollabOp(reviewSessionIDForRequest, data);
  }
  async openCPDFTocllaborationMode() {
    let status = false;
    let reviewSessionID = '';
    let cDocID = '';
    let fileLink = '';
    let docName = '';
    // TODO FOXIT 云编辑不在将文件转为CPDF，去除相关判断，使用docid
    // const isCPDF = await fileController.isCPDFForCurrentDoc().catch((error) => {
    //   throw error
    // })
    const { shareReviewData } = store.collaborationStore;
    // shareState: 0 正在分享, 1 停止分享
    // delFlag: 0 未删除， 1 已删除
    if (shareReviewData.shareState !== 1) {
      // TODO FOXIT 不在使用cpdf文档，将文件fileController.getCDocID()修改为输出docid
      // cDocID =
      cDocID = await this.getCDocId();
      const shareFileDetails = await this.getShareReview({ cDocID });
      if (shareFileDetails.ret === 0) {
        // TODO FOXIT
        let data = shareFileDetails.data[0];
        this.reviewSessionID &&
          shareFileDetails.data.length > 0 &&
          shareFileDetails.data.forEach((item) => {
            if (this.reviewSessionID === item.reviewSessionID) {
              data = item;
            }
          });
        // const data = shareFileDetails.data[0] || {}
        let prohibitComment = data.prohibitComment; // 文档级权限
        store.collaborationStore.setShareReviewData(data);

        if (data.delFlag === 0 && data.shareState === 0) {
          status = true;
          reviewSessionID = data && data.reviewSessionID;
          data.fileLink && (fileLink = data.fileLink);
          docName = data.docName;
        }
        if (this.cUserID) {
          data.memberList.forEach((item) => {
            if (item.cUserID === this.cUserID) {
              prohibitComment = item.prohibitComment;
            }
          });
        }
        if (prohibitComment === 1) {
          await enableCollaborationOnlyRead();
          store.collaborationStore.updateCanComment(false);
        }
      }
    }
    return new Promise((resolve) => {
      return resolve({ status, reviewSessionID, cDocID, fileLink, docName });
    });
  }
  getInitialAnnotsFDFArr() {
    const annotArr = store.collaborationStore.getAnnotInitialTree();

    if (!annotArr || !annotArr.length) {
      store.appStore.showLoading(false);

      return [];
    }

    let xfdf = header;
    renderAnnotRecursive(annotArr);
    return [{ file: new Blob([xfdf + tail], { type: 'application/vnd.xfdf' }) }];

    function renderAnnotRecursive(annotArr) {
      annotArr.forEach((annot) => {
        let { annotItem } = annot;
        if (annotItem.includes('date="D:')) {
          let date = annotItem.split('date="D:')[1].split('+')[0];
          annot.date = date;
        }
      });
      annotArr.sort((a, b) => {
        return a.date - b.date;
      });

      for (let i = 0; i < annotArr.length; i++) {
        const annot = annotArr[i];
        console.log(annot);

        let { annotItem, annotDelFlag } = annot;

        if (annotDelFlag === 1) {
          continue;
        }
        xfdf += annotItem;

        if (annot.subAnnotArr && annot.subAnnotArr.length) {
          renderAnnotRecursive(annot.subAnnotArr);
        }
      }
    }
  }
  async renderAnnot(annotArr) {
    if (annotArr && annotArr.length) {
      // let annotExistIDArr = await fileController.getDocAllAnnotsID()
      let doc = await pdfui.getCurrentPDFDoc().catch((error) => {
        throw error;
      });
      if (!doc) {
        return;
      }
      return await renderAnnotRecursive(annotArr).then(() => {
        store.appStore.showLoading(false);
      });

      async function renderAnnotRecursive(annotArr) {
        for (let i = 0; i < annotArr.length; i++) {
          const annot = annotArr[i];

          let { /* annotName, */ /* annotPage, */ annotItem, annotDelFlag } = annot;

          if (annotDelFlag === 1 /* || annotExistIDArr.indexOf(annotName) > -1 */) {
            continue;
          }

          let xfdfBlob;
          let xfdfAnnot = setAnnotToXFDF(annotItem);

          // console.log(xfdfAnnot);

          xfdfBlob = new Blob([xfdfAnnot], { type: 'application/vnd.xfdf' });

          try {
            await fileController.importXFDFToAnnots({ doc, xfdfBlob });
          } catch (error) {
            if (error.toString().indexOf('Permission error') > -1) {
              store.appStore.setGlobalMessage({ type: 'error', content: intl.get('PermissionError') });
            }
          }

          if (annot.subAnnotArr && annot.subAnnotArr.length) {
            await renderAnnotRecursive(annot.subAnnotArr);
          }
        }
      }
    } else {
      store.appStore.showLoading(false);
    }
  }
  renderAnnotInitialTree() {
    const annotTree = store.collaborationStore.getAnnotInitialTree();
    return this.renderAnnot(annotTree);
  }
  async getAnnotFromS3({ item }) {
    try {
      let annotItemResult = await collaborationApi.getAnnotFromS3({ item });
      const { ret, data } = annotItemResult;

      if (ret !== 0) {
        console.error('get annot faild');
        return;
      }

      if (data && data[0].item) {
        return data[0].item;
      }
    } catch (error) {
      console.error(error);
      return;
    }
  }
  showCollabOp(reviewSessionID, cUserID, operate) {
    // if(this.reviewSessionID!==reviewSessionID)return;

    const { userInfo } = store.userStore;
    // const annotRender = await pdfui.getAnnotRender(annotPage,operate.id)

    if (!userInfo || cUserID !== userInfo.cUserID) {
      pdfui.callAddonAPI('CollaborationOp', 'addCollabOp', operate);
    }
  }
  // TODO FOXIT 协同删除注释
  async deleteAnnot({ annotItem, pageIndex, annotName, isDeleteLocal, cUserID }) {
    if (!annotItem && (pageIndex === undefined || !annotName)) {
      return;
    }

    let annotId;
    const annotPageReg = /page=\"([^"]*)\"/;
    const annotNameReg = /name=\"([^"]*)\"/;
    const annotPage = pageIndex !== undefined ? pageIndex : parseInt(annotItem.match(annotPageReg)[0].split('=')[1].replaceAll('"', ''));
    const pageRender = await pdfui.pdfViewer.getPDFPageRender(annotPage);
    const pdfPage = await pageRender.getPDFPage();

    pdfPage.annots.some((annot) => {
      const annotData = annot.getName();

      if (annotData === annotName) {
        annotId = annot.getId();
        return true;
      }
    });
    const annotRender = await pdfui
      .getAnnotRender(annotPage, annotId || (annotItem && annotItem.match(annotNameReg)[0].split('=')[1].replaceAll('"', '')))
      .catch(() => {
        console.log('annot does not exist');
      });
    if (!annotRender) {
      annotId && pdfPage && pdfPage.removeAnnotById(annotId);
      return;
    }

    const userInfo = store.userNewStore.userData;

    // 发起者删除协作者的Annot
    // if ((!isDeleteLocal || cUserID === userInfo.cUserID) && store.collaborationStore.isShareReviewOwner() && !store.collaborationStore.isAnnotOwner(annotRender.component.annot.getName())) {
    //   store.collaborationStore.updateIsOwnerDeleteCollaboratorAnnot(true)
    // }
    if (isDeleteLocal && cUserID === userInfo.userId && !store.collaborationStore.isAnnotOwner(annotRender.component.annot.getName())) {
      store.collaborationStore.updateIsOwnerDeleteCollaboratorAnnot(true);
    }
    // 协作者被发起者删除Annot
    // if (isDeleteLocal && cUserID !== userInfo.cUserID) {
    //   store.collaborationStore.updateIsCollaboratorAnnotBeDeletedByOwner(true)
    // }
    if (isDeleteLocal && cUserID !== userInfo.userId && store.collaborationStore.isAnnotOwner(annotRender.component.annot.getName())) {
      store.collaborationStore.updateIsCollaboratorAnnotBeDeletedByOwner(true);
    }

    // Mqtt消息的操作需要将当前无权限的Annot临时设置为可删除状态
    annotRender.component.annot.$PERMISSION_DELETE = true;
    isDeleteLocal && (annotRender.component.annot.$DELETE_LOCAL = true);
    const authManager = await pdfui.getAnnotAuthorityManager().catch((error) => {
      throw error;
    });
    authManager.update(annotRender.component.annot);
    await annotRender.component.removeAnnot().catch((error) => {
      throw error;
    });
    console.log(annotName, pageIndex);
  }
  async getAnnotListAll({ reviewSessionID, lastTime, pageObjNum, annotType, isInitial }) {
    console.log('collaborationService.getAnnotListAll 5');
    let annotInitialArr = [];
    let doc = await pdfui.getCurrentPDFDoc();
    let res = await collaborationApi.getAnnotListAll({ reviewSessionID, lastTime, pageObjNum, annotType });
    let { ret, data: userAnnotList } = res;

    if (ret !== 0) {
      throw 'get annot fail';
    }
    // 没有数据
    if (userAnnotList.length === 1) {
      return;
    }
    for (let i = 0; i < userAnnotList.length; i++) {
      const annots = userAnnotList[i].notations;
      const userEmail = userAnnotList[i].userEmail || userAnnotList[i].userMobile;
      const cUserID = userAnnotList[i].cUserID;
      if (!annots) {
        continue;
      }

      const annotsUserID = userAnnotList[i].cUserID;

      for (let ii = 0; ii < annots.length; ii++) {
        let xfdfBlob;
        const annot = annots[ii];
        const annotName = annot.annotName;
        let annotItem = annot.item;
        const annotUpdateTime = annot.updateTime;

        // TODO FOXIT 云编辑信息
        if (store.userNewStore.userData && annotsUserID != store.userNewStore.userData.userId) {
          store.collaborationStore.updateOthersAnnotList(annotName);
        }

        if (!othersAnnotLastUpdate) {
          othersAnnotLastUpdate = annotUpdateTime;
        } else if (compareDate(othersAnnotLastUpdate).isBefore(annotUpdateTime)) {
          othersAnnotLastUpdate = annotUpdateTime;
        }
        if (annot.saveFlag === 2) {
          let res = await this.getAnnotFromS3({ item: annotItem });
          if (!res) {
            continue;
          }
          annotItem = res;
        }
        let annotDelFlag = annot.delFlag;
        let annotRenderInfo = getAnnotRenderInfo({ annotItem, annotName, annotDelFlag, userEmail, cUserID });

        if (isInitial) {
          annotInitialArr.push(annotRenderInfo);
          continue;
        }

        store.collaborationStore.addAnnotList([annotRenderInfo]);

        if (annot.delFlag === 1 && !isInitial) {
          this.deleteAnnot({ annotItem });
          continue;
        }
        let xmlAnnot = setAnnotToXFDF(annotItem);
        pdfui
          .callAddonAPI('CollaborationOp', 'showOp', [annotRenderInfo.annotPage, annotRenderInfo.annotItem.match(/title="([\s\S]*?)"/)[1]])
          .then(async () => {
            console.log(xmlAnnot);
            xfdfBlob = new Blob([xmlAnnot], { type: 'application/vnd.xfdf' });

            try {
              await fileController.importXFDFToAnnots({ doc, xfdfBlob });
              setTimeout(async () => {
                const { activeAnnot } = store.collaborationStore;
                console.log(activeAnnot);
                if (activeAnnot) {
                  setTimeout(async () => {
                    let pageRender = await pdfui.pdfViewer.getPDFPageRender(activeAnnot.page);
                    pageRender && pageRender.annotsRender && pageRender.annotsRender.activeAnnot && pageRender.annotsRender.activeAnnot(activeAnnot.name);
                  }, 0);
                }
              }, 1000);
            } catch (error) {
              if (error.toString().indexOf('Permission error') > -1) {
                store.appStore.setGlobalMessage({ type: 'error', content: intl.get('PermissionError') });
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    if (isInitial) {
      store.collaborationStore.updateAnnotInitialArr(annotInitialArr);
    }
    store.collaborationStore.updateAnnotLastUpdateTime(othersAnnotLastUpdate);
  }
  getNotificationPollingConfig() {
    return collaborationApi.getNotificationPollingConfig();
  }

  getNotificationStatistic() {
    return collaborationApi.getNotificationStatistic();
  }

  getNotificationIFrameSrc({ al }) {
    return collaborationApi.getNotificationIFrameSrc({ al });
  }
  async getReviewSessionID() {
    if (this.reviewSessionID) {
      return;
    }

    const reviewSessionIDResult = await docCollaborationApi.getReviewSessionID().catch((error) => {
      console.error(error);
    });

    if (!reviewSessionIDResult) {
      console.error('get reviewSessionID error');
      return;
    }

    let { ret } = reviewSessionIDResult;

    if (ret !== 0) {
      console.error('get reviewSessionID error');
      return;
    }

    this.reviewSessionID = reviewSessionIDResult.data.reviewSessionID;
    store.collaborationStore.setReviewSessionID(reviewSessionIDResult.data.reviewSessionID);
  }
  closeWindow() {
    docCollaborationApi.closeWindow();
  }
  async getMoreOperationData() {
    await this.getUserToken();
    await this.getReviewSessionID();
  }
  async showCommonModeSidebar() {
    const root = await pdfui.getRootComponent();
    const toolbar = root.getComponentByName('collaboration-toolbar');

    root.querySelectorAll('@layer').forEach((dialog) => dialog.hide());

    if (toolbar) {
      toolbar.hide();
    }
    document.querySelectorAll('.fv__ui-not-supported-collab').forEach((node) => {
      node.classList.remove('fv__ui-not-supported-collab');
    });
  }
  sendMentionMsg(options) {
    return collaborationApi.sendMentionMsg(options);
  }
  async unshare(reviewSessionID, password) {
    await this.getUserToken();
    return collaborationApi.unShare(reviewSessionID, password);
  }
}
